import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import Moment from 'react-moment';
import moment from 'moment';

const Profile = ({
  profile: { bio, location, relationship, social },
  user: { name, avatar, email, date }
}) => {
  return (
    <div className="card rounded-0 mt-3 shadow-sm">
      <div className="card-body">
        <Link to="/edit-profile" className="text-secondary float-right">
          <i className="fas fa-edit"></i>
        </Link>
        <div className="d-flex">
          <div className="edit-pic">
            <img
              src={avatar}
              className="rounded-circle dashboard-profile-pic"
              // style={{ height: '85px', width: '85px' }}
              alt=""
            />
          </div>

          <div className="ml-2 align-self-center">
            <h6 className="mb-0">{name}</h6>
            <span className="text-muted username rb">{email}</span>
            <div className="social">
              {social && social.facebook && (
                <a
                  href={social.facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                  className=""
                >
                  <i className="fab fa-facebook-square facebook"></i>
                </a>
              )}
              {social && social.twitter && (
                <a
                  href={social.twitter}
                  target="_blank"
                  rel="noopener noreferrer"
                  className=""
                >
                  <i className="fab fa-twitter twitter"></i>
                </a>
              )}
              {social && social.instagram && (
                <a
                  href={social.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  className=""
                >
                  <i className="fab fa-instagram instagram"></i>
                </a>
              )}
              {social && social.linkedin && (
                <a
                  href={social.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className=""
                >
                  <i className="fab fa-linkedin linkedin"></i>
                </a>
              )}
            </div>
          </div>
        </div>
        <div className="about mt-2 pb-0">
          <h6 className="d-inline ml-1">About</h6>

          {location && (
            <dl className="row mb-0 mt-1 mx-0 text-muted">
              <dt className="col-1">
                <i className="fas fa-home"></i>
              </dt>
              <dd className="col-10 mb-1 pl-2">
                <p className="text-muted mb-0">{location} Area</p>
              </dd>
            </dl>
          )}

          {relationship && (
            <dl className="row mb-0 mt-1 mx-0 text-muted">
              <dt className="col-1">
                <i className="fas fa-heart heart"></i>
              </dt>
              <dd className="col-10 mb-1 pl-2">
                <p className="text-muted mb-0">{relationship}</p>
              </dd>
            </dl>
          )}

          <dl className="row mb-0 mt-1 mx-0 text-muted">
            <dt className="col-1">
              <i className="far fa-calendar-alt"></i>
            </dt>
            <dd className="col-10 mb-0 pl-2">
              <p className="text-muted mb-0">
                Joined <Moment format="LL">{date}</Moment>
              </p>
            </dd>
          </dl>
        </div>
      </div>
    </div>
  );
};

Profile.propTypes = {
  profile: PropTypes.object.isRequired
};

export default Profile;
